export const reInt = /^[0-9]{0,10}$/;
export const reFloatTwoDecimals = /^[0-9]{0,8}\.?[0-9]{0,2}$/;
export const reDotBegin = /^\..*/;
